import { render } from "./TextEditorBlock.vue?vue&type=template&id=4ce38b1e&scoped=true"
import script from "./TextEditorBlock.vue?vue&type=script&lang=js"
export * from "./TextEditorBlock.vue?vue&type=script&lang=js"

import "./TextEditorBlock.vue?vue&type=style&index=0&id=4ce38b1e&lang=css"
import "./TextEditorBlock.vue?vue&type=style&index=1&id=4ce38b1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce38b1e"]])

export default __exports__